require('./quad-last-screenshots.component.scss');
import {
  PATH_STRING_SEPARATOR
} from '../../common/config.js';


class QuadLastScreenshotsController {
  constructor(
    $scope,
    $rootScope,
    $interval,
    $element,
    CurrentFilterDataService,
    FrameLoadService,
    CurrentFilterService,
    RouterService,
  ) {
    this.sep = PATH_STRING_SEPARATOR;
    this.$scope = $scope;
    this.$rootScope = $rootScope;
    this.$element = $element;
    this.RouterService = RouterService;
    this.CurrentFilterDataService = CurrentFilterDataService;
    this.reloading = false;

    $scope.$on('reload', () => {
      this.reloading = false;
      this.data = null;
    });

    this.$scope.$watch('$ctrl.CurrentFilterService.filter.filters', () => {
      this.reloading = false;
      this.data = null;
    }, true);

    this.$scope.$watch('$ctrl.CurrentFilterService.timeFrom', () => {
      this.reloading = false;
      this.data = null;
    }, true);

    this.CurrentFilterService = CurrentFilterService;
    this.subscription = this.CurrentFilterDataService.filterData.filterData$.subscribe(() => {
      if (!this.CurrentFilterService || !this.CurrentFilterService.lastScreenshots) return;
      this.setData();
    });
    this.$scope.$on('$destroy', () => this.subscription.dispose());
    $interval(() => this.reload(), 7000);
  }

  reload() {
    if (!this.reloading || !this.CurrentFilterService || !this.CurrentFilterService.lastScreenshots) return;
    this.CurrentFilterService.lastScreenshots.timeFrom = new Date((new Date()) - (1000 * 60 * 60));
    // console.log('lastScreenshots = ', this.CurrentFilterService.lastScreenshots);
    this.CurrentFilterDataService.reload();
  }

  setData() {
    if (this.data) {
      const keys = Object.keys(this.CurrentFilterDataService.filterData.filterData);
      keys.map(key => {
        if (!this.reloading || this.data[key])
          this.data[key] = this.CurrentFilterDataService.filterData.filterData[key];
      });
    } else {
      this.data = angular.copy(this.CurrentFilterDataService.filterData.filterData);
      this.reloading = true;
    }
  }

  get isNotLsatScreen() {
    return this.dataKeys && this.dataKeys.length > 1;
  }

  get dataKeys() {
    return this.data ? Object.keys(this.data) : 0;
  }

  getHead(key) {
    if (!this.data || !this.data[key]) return '';
    const d = this.data[key];
    return (d.computerName ? d.computerName + ' -> ' : '') +
      (d.fullName ? `${d.userName} (${d.fullName})` : d.userName);
  }

  getUrl(key) {
    if (!this.data || !this.data[key]) return '';
    return 'media/' + this.data[key].url;
  }

  getTime(key) {
    if (!this.data || !this.data[key]) return '';
    return this.data[key].localTime;
  }

  get screensQty() {
    const qty = this.dataKeys.length;
    if (qty < 3) return qty;
    if (qty < 5) return 4;
    if (qty < 7) return 6;
    if (qty < 9) return 8;
    if (qty < 13) return 12;
    return 15;
  }

  removeScreen(key) {
    if (this.dataKeys && this.dataKeys.length < 2) {
      this.RouterService.cleanRemoteUsers();
      window.CACHE.reset();
      this.$rootScope.$broadcast('reload');
    } else {
      delete this.data[key];
    }
  }

  get screenClass() {
    return 'size-' + this.screensQty;
  }

}

export const QuadLastScreenshotsComponent = {
  template: require('./quad-last-screenshots.component.html'),
  bindings: {},
  controller: QuadLastScreenshotsController,
};



// WEBPACK FOOTER //
// ./src/view/quad-last-screenshots/quad-last-screenshots.component.js